{
  "title": "Attendance",
  "description": "Mark who was in each lesson and see how a class is doing over a period.",
  "class": "Class",
  "selectClass": "Choose a class",
  "noClasses": {
    "title": "No classes to show",
    "teacherText": "You do not teach any class yet — attendance is marked per class.",
    "adminText": "This school has no classes yet. Attendance is marked once one exists.",
    "action": "Go to classes"
  },
  "from": "From",
  "to": "To",
  "clearRange": "Clear dates",
  "loadFailed": "Attendance could not be loaded.",
  "lessons": {
    "title": "Lessons in this period",
    "empty": "No lessons are scheduled for this class.",
    "marked": "Marked",
    "unmarked": "Not marked",
    "partial": "Partly marked",
    "markedCount": "{{marked}} of {{total}} pupils",
    "open": "Mark",
    "reopen": "Edit marks",
    "emptyFiltered": "No lessons fall inside these dates. Clear them to see every lesson."
  },
  "totals": {
    "title": "Period summary",
    "percent": "Attendance {{percent}}%",
    "noData": "Nothing has been marked yet."
  },
  "statuses": {
    "present": "Present",
    "absent": "Absent",
    "late": "Late",
    "excused": "Excused"
  },
  "marking": {
    "title": "{{lesson}}",
    "back": "Back to lessons",
    "roster": "Roster",
    "emptyRoster": "No pupils are enrolled in this class yet.",
    "statusFor": "Attendance for {{pupil}}",
    "note": "Note",
    "notePlaceholder": "Optional note",
    "noteFor": "Note for {{pupil}}",
    "markAllPresent": "Mark all present",
    "save": "Save attendance",
    "saved": "Attendance saved.",
    "saveFailed": "Attendance could not be saved.",
    "summary": "Present {{present}} · Late {{late}} · Excused {{excused}} · Absent {{absent}}"
  },
  "export": {
    "csv": "Export CSV",
    "xlsx": "Export XLSX",
    "started": "Your export is downloading.",
    "failed": "The export could not be downloaded."
  }
}
